module.exports = __webpack_public_path__ + "static/media/cms.67ceff87.png";